module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', [_c('el-alert', {
    attrs: {
      "title": "企业标签",
      "type": "warning",
      "description": "仅供浏览!",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "切换企业"
    },
    on: {
      "change": _vm.typesearch
    },
    model: {
      value: (_vm.params.corp_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "corp_id", $$v)
      },
      expression: "params.corp_id"
    }
  }, _vm._l((_vm.corpList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "size": "mini",
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.catesList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "group_name",
      "label": "标签组",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "taglist",
      "label": "标签"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.taglist), function(taglist) {
          return _c('el-tag', {
            key: taglist.index,
            staticStyle: {
              "display": "inline-block",
              "margin-right": "3px"
            },
            style: ('color:' + taglist.font_color),
            attrs: {
              "type": "danger",
              "color": taglist.tag_color,
              "size": "mini"
            }
          }, [_vm._v(_vm._s(taglist.name))])
        })
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74c12ba0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74c12ba0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/workwx/tag.vue
// module id = 2829
// module chunks = 0